import { LinkButton } from "./Buttons";
import CircleIcon from "./CircleIcon";
import Header from "./Header";
import ResultsBar from "./ResultsBar";
import Section from "./Section";
import Input, { TextArea } from "./Input";
import ErrorMessage from "./ErrorMessage";
import Select from "./Select/Select";
import Tooltip from "./Tooltip";

const Line = () => <hr className="border-grey-400 mt-6 pt-6" />;

export {
  Section,
  Header,
  CircleIcon,
  Line,
  LinkButton,
  ResultsBar,
  Input,
  TextArea,
  ErrorMessage,
  Select,
  Tooltip,
};
